import constants from 'constants';

const {GET_ZOOM_ACCOUNTS, SET_ZOOM_ACCOUNTS} = constants;

export const getZoomAccounts = () => ({
  type: GET_ZOOM_ACCOUNTS,
});

export const setZoomAccounts = zoomAccounts => ({
  type: SET_ZOOM_ACCOUNTS,
  payload: {zoomAccounts},
});



// WEBPACK FOOTER //
// ./src/actions/zoom.js